import React, { useEffect, useRef } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const linkSx = {
  color: 'rgba(255,255,255,0.6)',
  fontSize: { xs: '0.72rem', sm: '0.8rem' },
  fontWeight: 500,
  textTransform: 'uppercase',
  letterSpacing: { xs: '0.02em', sm: '0.06em' },
  whiteSpace: 'nowrap',
  transition: 'color 0.2s',
  '&:hover': { color: '#fff' },
};

export default function Footer() {
  const { t } = useTranslation();
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => {
      document.documentElement.style.setProperty(
        '--footer-height',
        `${el.offsetHeight}px`
      );
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener('resize', update);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <Box
      ref={ref}
      component="footer"
      sx={{
        backgroundColor: '#0063a6',
        pt: 1.5,
        pb: 'calc(12px + env(safe-area-inset-bottom))',
        px: { xs: 1, sm: 3 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.75,
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: { xs: 1.25, sm: 3 },
          flexWrap: { xs: 'nowrap', sm: 'wrap' },
          justifyContent: 'center',
          maxWidth: '100%',
        }}
      >
        <Link href="/signup" underline="none" sx={linkSx}>
          {t('button_register_your_company')}
        </Link>
        <Link href="/login" underline="none" sx={linkSx}>
          {t('button_login')}
        </Link>
        <Link
          href="https://www.gets.saarland/datenschutz/"
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          sx={linkSx}
        >
          {t('button_privacy_policy')}
        </Link>
        <Link
          href="https://www.gets.saarland/impressum/"
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          sx={linkSx}
        >
          {t('button_legal_notice')}
        </Link>
      </Box>
    </Box>
  );
}
